import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const exportWarehouseViewToPDF = async (warehouseItems, totalItems) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const margin = 10;
    let yPos = margin;

    // Add header - reduced top spacing
    doc.setFillColor(218, 218, 218);
    doc.rect(margin, yPos, pageWidth - 2 * margin, 12, 'F'); // Reduced height
    
    doc.setFontSize(14);
    doc.setTextColor(0);
    doc.text('Warehouse Picking List', pageWidth / 2, yPos + 5, { align: 'center' });
    doc.setFontSize(10);
    doc.text(`Total Items: ${totalItems} | Generated: ${new Date().toLocaleString()}`, pageWidth / 2, yPos + 10, { align: 'center' });
    
    yPos += 15; // Reduced spacing after header

    // Process each item
    for (const item of Object.values(warehouseItems)) {
        if (yPos > doc.internal.pageSize.height - 25) {
            doc.addPage();
            yPos = margin;
        }

        // Item container - reduced height
        const itemHeight = 16 + (item.orders.length * 4); // Reduced from 20 to 16
        doc.setFillColor(248, 249, 250);
        doc.setDrawColor(222, 226, 230);
        doc.roundedRect(margin, yPos, pageWidth - 2 * margin, itemHeight, 2, 2, 'FD');

        // Add image if available
        if (item.image_url) {
            try {
                const img = await loadImage(item.image_url);
                doc.addImage(img, 'JPEG', margin + 3, yPos + 2, 14, 14); // Reduced size
            } catch (error) {
                console.error('Error loading image:', error);
            }
        }

        // Product info and SKU - moved up
        doc.setFontSize(10);
        doc.setTextColor(0);
        doc.text(item.title, margin + 22, yPos + 6); // Moved up from 7
        doc.setFontSize(7);
        doc.setTextColor(136, 136, 136);
        doc.text(item.sku || 'No SKU', margin + 22, yPos + 10); // Moved up from 11

        // Size/Variant box (right side)
        const sizeBoxWidth = 35;
        const sizeBoxHeight = 12;
        const sizeBoxX = pageWidth - margin - 65;
        const sizeBoxY = yPos + 2;
        
        doc.setFillColor(233, 236, 239);
        doc.roundedRect(sizeBoxX, sizeBoxY, sizeBoxWidth, sizeBoxHeight, 2, 2, 'FD');
        
        // Center text vertically and horizontally in size box
        doc.setTextColor(44, 62, 80);
        doc.setFontSize(10);
        const sizeText = item.variant_title || 'Default';
        const sizeTextWidth = doc.getStringUnitWidth(sizeText) * 10 / doc.internal.scaleFactor;
        const sizeTextX = sizeBoxX + (sizeBoxWidth - sizeTextWidth) / 2;
        const sizeTextY = sizeBoxY + (sizeBoxHeight / 2) + 1; // Adjusted vertical centering
        doc.text(sizeText, sizeTextX, sizeTextY);

        // Quantity box (far right)
        const qtyBoxWidth = 20;
        const qtyBoxHeight = 12;
        const qtyBoxX = pageWidth - margin - 25;
        const qtyBoxY = yPos + 2;
        
        doc.setFillColor(232, 245, 233);
        doc.setDrawColor(76, 175, 80);
        doc.roundedRect(qtyBoxX, qtyBoxY, qtyBoxWidth, qtyBoxHeight, 2, 2, 'FD');
        
        // Center text vertically and horizontally in quantity box
        doc.setTextColor(35, 151, 39);
        doc.setFontSize(11);
        const qtyText = `×${item.total_quantity}`;
        const qtyTextWidth = doc.getStringUnitWidth(qtyText) * 11 / doc.internal.scaleFactor;
        const qtyTextX = qtyBoxX + (qtyBoxWidth - qtyTextWidth) / 2;
        const qtyTextY = qtyBoxY + (qtyBoxHeight / 2) + 1; // Adjusted vertical centering
        doc.text(qtyText, qtyTextX, qtyTextY);

        // Orders list - moved up
        doc.setFontSize(8);
        let orderY = yPos + 15; // Moved up from 17

        item.orders.forEach(order => {
            doc.setTextColor(35, 151, 39);
            doc.text(`#${order.order_number}`, margin + 22, orderY);
            doc.text(`×${order.quantity}`, margin + 55, orderY);
            
            doc.setTextColor(68, 68, 68);
            doc.text(order.customer, margin + 70, orderY);
            
            orderY += 4;
        });

        yPos += itemHeight + 2;
    }

    doc.save(`warehouse-picking-list-${new Date().toISOString().split('T')[0]}.pdf`);
};

// Helper function to load images
const loadImage = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';  // Handle CORS
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/jpeg'));
        };
        img.onerror = reject;
        img.src = url;
    });
}; 